import { TranslationKey } from '@tolgee/ngx';

export interface TranslatableItem {
  key: TranslationKey;
  params?: { [key: string]: string | number | TranslatableItem };
  defaultValue?: string;
}

export function isTranslatableItem(obj: any): obj is TranslatableItem {
  return typeof obj === 'object' && obj && 'key' in obj;
}
